import AllMovies from './AllMovies';

export default AllMovies;
